import React from 'react';
import { InfoButton } from '../../../../../../common/components';
import cx from 'classnames';
import FaSuitcase from 'react-icons/lib/fa/suitcase';
import SchemeSelectButton from '../SchemeSelectButton/SchemeSelectButton';
import SmartLuggagePremiumBreakdown from '../../../SmartLuggagePremiumBreakdown/SmartLuggagePremiumBreakdown';
import './CalculatedPremium.scss';
import { DotLoader } from '../../../../../../common/components/Loader/Loader';

const CalculatedPremiumContainer = ({
  schemeTypeDefinition,
  schemeType,
  isNotSelected,
  children,
}) => {
  return (
    <div
      className={cx('calculated-premium', {
        'calculated-premium--is-not-selected': isNotSelected,
      })}
    >
      <div className={'calculated-premium--title'}>
        <div>
          {schemeType} trip &nbsp;
          <InfoButton white content={schemeTypeDefinition} />
        </div>
        <div className={'calculated-premium--icon'}>
          <FaSuitcase />
        </div>
      </div>
      <div className={'calculated-premium--body'}>{children}</div>
    </div>
  );
};

const Select = ({
  isCalculating,
  premium,
  handleToggleScheme,
  hasSchemesSelected,
  isSelected,
  numTravellers,
}) => {
  if (isCalculating) {
    return (
      <div className={'calculated-premium--calculating'}>
        Recalculating
        <DotLoader />
      </div>
    );
  }
  const perTraveller = numTravellers ? premium.premium.gross / numTravellers : 0;
  return (
    <div className={'calculated-premium--payable'}>
      <div className={'total-payable-title'}>
        <span className={'total-payable-total'}> Total Payable: </span>
        <span>
          <SmartLuggagePremiumBreakdown premium={premium} />
        </span>
      </div>

      <span className={'total-payable-each'}>
        £{perTraveller.toFixed(2)} each including IPT
      </span>
      <div className={'select-button'}>
        <SchemeSelectButton
          handleToggleScheme={handleToggleScheme}
          hasSchemesSelected={hasSchemesSelected}
          isSelected={isSelected}
          block
          bsStyle="primary"
          label={'Select'}
        />
      </div>
    </div>
  );
};

const Benefit = ({ benefit, isSubBenefit }) => (
  <div
    className={cx({
      'calculated-premium--sub-benefit': isSubBenefit,
      'calculated-premium--benefit': !isSubBenefit,
    })}
  >
    <span className={'calculated-premium--benefit-title'}>{benefit.name} </span>
    <br />
    <span className={'calculated-premium--benefit-text'}>{benefit.text}</span>
    {benefit.sub_benefits &&
      benefit.sub_benefits.map((subBenefit) => (
        <Benefit benefit={subBenefit} isSubBenefit />
      ))}
  </div>
);
const CalculatedPremium = ({
  premium,
  isSelected,
  hasSchemesSelected,
  definitions,
  numTravellers,
  toggleSchemeSelect,
  isCalculating,
}) => {
  const handleToggleScheme = () => {
    toggleSchemeSelect(premium.scheme.id);
  };

  const errors = premium?.errors ?? [];
  const allErrors = errors.concat(premium?.declines ?? []);
  const errorMessages = allErrors.map((error) => error?.reason ?? error);
  if (allErrors.length) {
    return (
      <CalculatedPremiumContainer
        isNotSelected={hasSchemesSelected && !isSelected}
        schemeType={premium.scheme.scheme_type}
        schemeTypeDefinition={definitions.scheme_type[premium.scheme.scheme_type]}
      >
        {errorMessages.join(', ')}
      </CalculatedPremiumContainer>
    );
  }

  // const perTraveller = numTravellers ? premium.premium.gross / numTravellers : 0;
  return (
    <CalculatedPremiumContainer
      isNotSelected={hasSchemesSelected && !isSelected}
      schemeType={premium.scheme.scheme_type}
      schemeTypeDefinition={definitions.scheme_type[premium.scheme.scheme_type]}
    >
      <div className={'calculated-premium--benefits'}>
        {premium.benefits.map((benefit) => (
          <Benefit benefit={benefit} />
        ))}
      </div>

      <Select
        isCalculating={isCalculating}
        premium={premium}
        handleToggleScheme={handleToggleScheme}
        hasSchemesSelected={hasSchemesSelected}
        isSelected={isSelected}
        numTravellers={numTravellers}
      />
    </CalculatedPremiumContainer>
  );
};

export default CalculatedPremium;
